import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import Loader from '../component/common/loader';

const OtherLayout = (props) => {
    return (
        <Fragment>
            <div>
                <Loader />
                <Outlet />
            </div>
        </Fragment>
    )
}
export default OtherLayout;
